export default __webpack_public_path__ + "static/media/banner-home-2.d389c047.png";